import { BigNumberish, PopulatedTransaction } from 'ethers'

export interface TxBatchInterface {
  txs: PopulatedTransaction[]
  gasPrice?: BigNumberish
  signatures?: string[]
}
export enum Policies {
  Custodied = 'custodied',
  Self = 'self',
  Multisig = 'multisig',
}
